module.exports = __webpack_public_path__ + "img/tag1.19bd5159.png";